import {FieldRoot} from '../../components/form/field-root.js'
import {useFieldContext} from '../../integrations/form/index.js'
import {Box, Input, InputGroup, InputProps} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuSearch, LuX} from 'react-icons/lu'

export function Searchbox(props: InputProps) {
  const {t} = useTranslate('common')
  const field = useFieldContext<string>()

  function onChange(value: string) {
    field.handleChange(value)
  }

  return (
    <FieldRoot>
      <InputGroup
        startElement={<LuSearch opacity="0.7" />}
        endElement={
          <Box asChild width="100%" height="100%" cursor="pointer">
            <button type="button" title={t('clear')} onClick={() => onChange('')}>
              <LuX />
            </button>
          </Box>
        }
      >
        <Input
          type="search"
          width="100%"
          maxWidth="15rem"
          size="sm"
          rounded="md"
          placeholder={`${t('search')}...`}
          name={field.name}
          value={field.state.value}
          onChange={e => onChange(e.target.value)}
          onBlur={() => field.handleBlur()}
          {...props}
        />
      </InputGroup>
    </FieldRoot>
  )
}
